import {
  canBrowserPlayAudio,
  isElectronApp,
  dataURLtoFile,
  getBackgroundStyleFromImageFile,
  pause,
  isUrlBlob,
  getFileSize,
  loadFile,
  canRecordVideoAsync,
  getBackgroundStyleFromImageURL,
  canRecordVideo,
  isPro,
  cloneObject,
  isCustomFont,
  cleanCustomFontName,
  setValueInLocalStorage,
  postMessageToIosWrapper,
  newUUID,
  getValueFromLocalStorage,
  loadImage
} from '../../utils';
import { Soundtrack } from '../../audio/Soundtrack';
import Layer from '../../data/Layer';
import { FrameType } from '../../data/FrameType';
import {
  ADDED_EFFECT_STORAGE_KEY,
  INTRO_STORAGE_KEY,
  TOUR_POSITION_STORAGE_KEY,
  LOG_STATUS_STORAGE_KEY,
  INITIAL_FONT,
  GIF_FPS,
  VIDEO_FPS,
  TRANSCRIBE_LANGUAGE_STORAGE_KEY,
  MAX_CAPTIONS_DURATION
} from '../../data/Config';
import { Frame } from '../../data/Frame';
import { Resolution } from '../../data/Resolution';
import { AUDIO_SOURCE_IDS } from '../../audio/AudioSource';
import RootState from '../RootState';
import { BeatMotionSource } from '../../motion/BeatMotionSource';
import PixelRatio from '../../data/PixelRatio';
import Recorder, { RecorderEvent } from '../../video/Recorder';
import RecordType from '../../data/RecordType';
import { reportBFError, trackEvent } from '../../utils/Tracker';
import {
  loadUser,
  getExamples,
  addUserVideo,
  saveLastVideoToUser,
  incrementVideoCounter,
  updateTranscribeSpokenLanguage,
  setUserColorThemes,
  setUserCustomFonts,
  getUserCustomFonts
} from '../../utils/FirebaseUtils';
import User, { CustomFont } from '../../data/User';
import FlyerType from '../../data/FlyerType';
import { getAudioContext } from '../../audio/Context';
import Alert from '../../data/Alert';
import {
  addCustomResolution,
  getTemplateById
} from '../../utils/FirebaseUtils';
import { getFlyer } from '../../utils/FirebaseUtils';
import {
  FlatStorableMotionData,
  FlyerData,
  isMotionSourceData,
  LayerData,
  parseBindPath,
  PictureFrameData,
  PointData,
  RectData,
  SolidFrameData,
  StorableMotionData,
  TemplateImageContentMode,
  TemplateUI,
  TemplateUIBind,
  TemplateUIBindOptions,
  TemplateUIIntroType,
  TemplateUIType,
  TextFrameData
} from '../../data/FlyerData';
import { matchResolutionWithStandards } from '../../data/Resolution';
import { getRenderer, getStage, getStageBackground } from '../Store';
import {
  getStageLuminosity,
  getStageScreenshotFile
} from '../../utils/GraphicsUtils';
import { ModalType, ModalData } from '../../data/ModalData';
import Label from '../../audio-editing/Label';
import GIFRecorder from '../../video/GIFRecorder';
import VideoRecorder from '../../video/VideoRecorder';
import ElectronRecorder from '../../video/ElectronRecorder';
import { BrowserAsyncRecorder } from '../../video/BrowserAsyncRecorder';
import { H264AsyncRecorder } from '../../video/H264AsyncRecorder';
import TourStep from '../../tour/TourSteps';
import { deleteFile, getBaseURL, uploadFile } from '../../utils/S3Utils';
import FileType from '../../data/FileType';
import { MotionSource, MotionSourceType } from '../../motion/MotionSource';
import { MuteMotionSource } from '../../motion/MuteMotionSource';
import { BinaryMotionSource } from '../../motion/BinaryMotionSource';
import { LinearLoopMotionSource } from '../../motion/LinearLoopMotionSource';
import { FullOnMotionSource } from '../../motion/FullOnMotionSource';
import { TextAlignment } from '../../data/TextAlignment';
import { TextFrame } from '../../data/TextFrame';
import { SolidFrame } from '../../data/SolidFrame';
import { PictureFrame } from '../../data/PictureFrame';
import { Effect } from '@beatflyer/shaders-lib';
import { SoundWaveFrame } from '../../data/SoundWaveFrame';
import { download } from '../../utils/Download';
import { isSoundtrackSignal, SignalSource } from '../../data/SignalSource';
import Loop from '../../audio-editing/Loop';
import AppState, { isFigmaPro, TemplateEditMode } from '../AppState';
import { extractAudioFileFromVideo } from '../../audio/AudioUtils';
import { getWaveformsFromBuffer, sampleBuffer } from '@beatflyer/audio-lib';
import FlyerState, { getExportedFileName } from 'state/FlyerState';
import { sizeToString } from 'data/Size';
import {
  CompositionEffect,
  DIRECTION_VERTICAL,
  DURATION_LONG
} from 'compose/CompositionEffect';
import { IRecordingOptions } from 'data/IRecordingOptions';
import MusicGenre from 'audio-editing/MusicGenre';
import { CaptionsToken } from 'data/CaptionsToken';
import { CaptionsFrame } from 'captions/CaptionsFrame';
import { getSpokenLanguage } from 'utils/Transcribe';
import { ShapeFrame } from 'data/ShapeFrame';
import { ColorTheme } from 'data/ColorTheme';
import { loadCustomFont } from 'utils/FontUtils';
import { RemoveFrameCommand } from 'state/commands/RemoveFrameCommand';
import { RemoveLayerCommand } from 'state/commands/RemoveLayerCommand';
import { EditShapeCommand } from 'state/commands/EditShapeCommand';
import {
  AddPictureFrameCommand,
  resizeImageFileIfNecessary
} from 'state/commands/AddPictureFrameCommand';
import { AddSoundtrackCommand } from 'state/commands/AddSoundtrackCommand';
import { RemoveSoundtrackCommand } from 'state/commands/RemoveSoundtrackCommand';
import { EditResolutionCommand } from 'state/commands/EditResolutionCommand';
import { AddCaptionsCommand } from 'state/commands/AddCaptionsCommand';
import { AddCaptionsFrameCommand } from 'state/commands/AddCaptionsFrameCommand';
import { PlatformType } from 'data/PlatformType';
import { IosRecorder } from 'video/iOSRecorder';
import { getSmoothness, PlaybackSmoothness } from 'data/PlaybackSmoothness';
import { PropertyTimeline } from 'data/LayerTimeline';
import { FigmaPaymentStatus } from 'data/Figma';
import { removeBackground } from 'state/commands/RemoveBackgroundCommand';
import { AddFigmaLayersPayload } from './payloads';
import { SKIP_FROM_DATA_ONBOARDING_STORAGE_KEY } from 'modals/FromDataOnboarding';

const Sentry = (window as any).Sentry;
// const invariant = require('invariant');

export const SELECT_FLYER = 'SELECT_FLYER';
export const TOGGLE_PLAYBACK = 'TOGGLE_PLAYBACK';
export const REWIND = 'REWIND';
export const JUMP_PLAYBACK = 'JUMP_PLAYBACK';
export const TOGGLE_AUDIO_MUTE = 'TOGGLE_AUDIO_MUTE';

export const SHOW_EFFECT_PREVIEW = 'SHOW_EFFECT_PREVIEW';
export const CANCEL_EFFECT_PREVIEW = 'CANCEL_EFFECT_PREVIEW';
// export const ADD_PREVIEWED_EFFECT = 'ADD_PREVIEWED_EFFECT';

export const ADDED_FILTER = 'ADDED_FILTER';
export const REMOVE_FILTER = 'REMOVE_FILTER';
export const TOGGLE_FILTER_VISIBILITY = 'TOGGLE_FILTER_VISIBILITY';
export const RESET_EFFECT = 'RESET_EFFECT';
export const EDITED_EFFECT = 'EDITED_EFFECT';
export const EDITED_BOUNDING_BOX = 'EDITED_BOUNDING_BOX';
export const EDITED_TEXT = 'EDITED_TEXT';
export const EDITED_SOLID_COLOR = 'EDITED_SOLID_COLOR';
export const EDITED_GRADIENT = 'EDITED_GRADIENT';
export const EDITED_SOUNDWAVE = 'EDITED_SOUNDWAVE';
export const EDITED_SHAPE = 'EDITED_SHAPE';

// export const ADD_LAYER = 'ADD_LAYER';
export const ADD_LAYERS = 'ADD_LAYERS';
export const REMOVE_LAYER = 'REMOVE_LAYER';
export const RESTORE_LAYER = 'RESTORE_LAYER';
export const CHANGE_MOTION_SOURCE = 'CHANGE_MOTION_SOURCE';
export const ADD_AUDIO = 'ADD_AUDIO';
export const RECORDING_NOT_SMOOTH = 'RECORDING_NOT_SMOOTH';
export const RECORDING_READY = 'RECORDING_READY';
export const SET_AUDIO_FADE_LENGHT = 'SET_AUDIO_FADE_LENGHT';
export const ADD_FRAME = 'ADD_FRAME';
export const REPLACE_FRAME = 'REPLACE_FRAME';
export const REMOVE_FRAME = 'REMOVE_FRAME';
// export const APPLY_SETTINGS = 'APPLY_SETTINGS';

export const START_RECORDING = 'START_RECORDING';
export const RECORDING_STOPPED = 'RECORDING_STOPPED';
export const RECORDING_ENDED = 'RECORDING_ENDED';
export const PREPARING_VIDEO_UPLOAD = 'PREPARING_VIDEO_UPLOAD';
export const UPLOAD_VIDEO = 'UPLOAD_VIDEO';
export const UPLOAD_VIDEO_PROGRESSED = 'UPLOAD_VIDEO_PROGRESSED';
// export const VIDEO_CONVERSION_ENDED = 'VIDEO_CONVERSION_ENDED';
// export const VIDEO_CONVERSION_FAILED = 'VIDEO_CONVERSION_FAILED';
export const VIDEO_DOWNLOAD_ENDED = 'VIDEO_DOWNLOAD_ENDED';

export const WILL_LOAD_EXAMPLE = 'WILL_LOAD_EXAMPLE';
export const LOAD_EXAMPLE = 'LOAD_EXAMPLE';

export const SHOWN_ERROR = 'SHOWN_ERROR';

export const USER_SIGN_IN = 'USER_SIGN_IN';
export const RESET = 'RESET';
export const UPDATE_USER = 'UPDATE_USER';
export const BLOCK_USER = 'BLOCK_USER';

export const CHANGE_RESOLUTION = 'CHANGE_RESOLUTION';
export const CHANGE_PREVIEW_PIXELRATIO = 'CHANGE_PREVIEW_PIXELRATIO';

export const SET_MAX_MUTED_DURATION = 'SET_MAX_MUTED_DURATION';
export const SET_MUTED_BPM = 'SET_MUTED_BPM';
export const REMOVE_SOUNDTRACK = 'REMOVE_SOUNDTRACK';

export const CHANGE_LAYER_REPEAT = 'CHANGE_LAYER_REPEAT';
export const CHANGE_LAYER_BLEND = 'CHANGE_LAYER_BLEND';

export const CHANGE_LAYER_SYNC_PLAYBACK = 'CHANGE_LAYER_SYNC_PLAYBACK';
export const TOGGLE_LAYER_VISIBILITY = 'TOGGLE_LAYER_VISIBILITY';
export const TOGGLE_LAYER_LOCK = 'TOGGLE_LAYER_LOCK';

export const SPLIT_LAYER = 'SPLIT_LAYER';
export const DUPLICATE_LAYER = 'DUPLICATE_LAYER';

export const SORT_FILTERS = 'SORT_FILTERS';
export const SORT_LAYERS = 'SORT_LAYERS';
export const SORT_FRAMES = 'SORT_FRAMES';

export const SHOW_ALERT = 'SHOW_ALERT';
export const CLOSE_ALERT = 'CLOSE_ALERT';
export const CLOSE_ALL_ALERTS = 'CLOSE_ALERT';

export const VIDEO_SHARED = 'VIDEO_SHARED';
export const RESTORE_FREE_PLAN = 'RESTORE_FREE_PLAN';
export const USER_DID_INTERACT = 'USER_DID_INTERACT';

export const UPDATE_TOUR_STEP = 'UPDATE_TOUR_STEP';

export const WILL_COMPRESS_RECORDING = 'WILL_COMPRESS_RECORDING';
export const DID_COMPRESS_RECORDING = 'DID_COMPRESS_RECORDING';

export const BROWSE_EFFECTS = 'BROWSE_EFFECTS';

export const FLYER_CREATED = 'FLYER_CREATED';
export const WILL_SAVE_FLYER = 'WILL_SAVE_FLYER';
export const SAVE_STATE_CHANGED = 'SAVE_STATE_CHANGED';
export const ASSET_UPLOADED = 'ASSET_UPLOADED';
export const DID_REMOVE_ASSETS = 'DID_REMOVE_ASSETS';
export const DID_ADD_ASSETS = 'DID_ADD_ASSETS';

export const WILL_START_RENDERING_QUEUE = 'WILL_START_RENDERING_QUEUE';
export const ADDED_FIGMA_LAYERS = 'ADDED_FIGMA_LAYERS';
export const UPDATE_FIGMA_PAYMENT_STATUS = 'UPDATE_FIGMA_PAYMENT_STATUS';

export const EDIT_TIMELINE = 'EDIT_TIMELINE';
export const CANCEL_EDIT_TIMELINE = 'CANCEL_EDIT_TIMELINE';
export const CHANGE_TIMELINE = 'CHANGE_TIMELINE';
export const SAVE_EDIT_TIMELINE = 'SAVE_EDIT_TIMELINE';

export const EDIT_MOTION_SOURCE = 'EDIT_MOTION_SOURCE';
export const CANCEL_EDIT_MOTION_SOURCE = 'CANCEL_EDIT_MOTION_SOURCE';
export const SAVE_EDIT_MOTION_SOURCE = 'SAVE_EDIT_MOTION_SOURCE';

export const SELECT_FRAME = 'SELECT_FRAME';
export const SELECT_MASK = 'SELECT_MASK';

export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

export const OPEN_PAGE = 'OPEN_PAGE';
export const CLOSE_PAGE = 'CLOSE_PAGE';

export const SHOW_MOBILE_CONTROLLER = 'SHOW_MOBILE_CONTROLLER';
export const HIDE_MOBILE_CONTROLLER = 'HIDE_MOBILE_CONTROLLER';

export const DID_LOAD_TEMPLATES = 'DID_LOAD_TEMPLATES';

export const DID_GO_BACK_WITH_BROWSER = 'DID_GO_BACK_WITH_BROWSER';
export const DID_RENAME_PROJECT = 'DID_RENAME_PROJECT';

export const UNDO = 'UNDO';
export const REDO = 'REDO';

export const APP_WILL_ENTER_BACKGROUND = 'APP_WILL_ENTER_BACKGROUND';
export const APP_DID_ENTER_FOREGROUND = 'APP_DID_ENTER_FOREGROUND';

export const TEMPLATE_PROPERTY_CHANGED = 'TEMPLATE_PROPERTY_CHANGED';

export const undo = () => {
  return {
    type: UNDO
  };
};

export const redo = () => {
  return {
    type: REDO
  };
};

// let warnedAboutLiveRecordingForVideos = false;
// const showLiveRecordingAlert = () => {
//   if (!warnedAboutLiveRecordingForVideos && canRecordVideoAsync()) {
//     if (!canRecordVideoSync()) {
//       alert(
//         'Your browser cannot record video layers. Please use a recent version of Google Chrome or Mozilla Firefox to create videos.'
//       );
//     } else {
//       alert('To record smoothly video layers you need a fast computer');
//     }
//     warnedAboutLiveRecordingForVideos = true;
//   }
// };

export const openModal = (
  modalType: ModalType,
  data: any = null,
  stack: boolean = false,
  uncloseable: boolean = false
) => {
  const modalData: ModalData = {
    type: modalType,
    data,
    uncloseable
  };
  return {
    type: OPEN_MODAL,
    modalData,
    stack
  };
};

const _goBack = (history: any) => {
  if (history.length) {
    history.goBack();
  } else {
    history.replace('/');
  }
};

export const goBack = () => {
  return (dispatch: Function, getState: () => RootState) => {
    const history = getState().app.history;
    const path = history.location.pathname;
    if (path === '/buy' || path === '/library' || path === '/account') {
      if (getState().flyer.id === null && history.action === 'POP') {
        history.replace('/');
        return;
      }
    }
    _goBack(history);
  };
};

export const closeModal = (dontResumePlayback: boolean = false) => {
  return (dispatch: Function, getState: () => RootState) => {
    const { openedModals, history } = getState().app;
    const path = history.location.pathname;
    if (path === '/buy' || path === '/library') {
      // if (getState().flyer.id === null && history.action === 'POP') {
      //   history.replace('/');
      //   return;
      // }
      dispatch(goBack());
      return;
    }
    if (openedModals.length) {
      const modal = openedModals[0];
      if (modal.type === ModalType.ReviewRecording) {
        const url: string = modal.data.url;
        if (isUrlBlob(url)) {
          URL.revokeObjectURL(url);
        }
      }
    }
    dispatch({
      type: CLOSE_MODAL,
      dontResumePlayback
    });
  };
};

const updateStoredTourStep = (step: number) => {
  setValueInLocalStorage(TOUR_POSITION_STORAGE_KEY, step.toString());
};

export const updateTourStep = (step: number) => {
  updateStoredTourStep(step);
  return {
    type: UPDATE_TOUR_STEP,
    step
  };
};

export const skipTourStepIfEqualsTo = (step: number) => {
  return (dispatch: Function, getState: () => RootState) => {
    const { tourIndex } = getState().app;
    if (tourIndex === step) {
      let nextStep = step === TourStep.Help ? -1 : step + 1;
      dispatch(updateTourStep(nextStep));
    }
  };
};

export const skipTour = () => {
  return updateTourStep(-1);
};

export const restartTour = () => {
  return updateTourStep(0);
};

export const showAlert = (alert: Alert) => {
  return {
    type: SHOW_ALERT,
    alert
  };
};

export const showError = (error: Error) => {
  return showAlert(new Alert('Something went wrong 🤦‍', error.message));
};

export const closeAlert = () => {
  return {
    type: CLOSE_ALERT
  };
};

export const closeAllAlerts = () => {
  return {
    type: CLOSE_ALL_ALERTS
  };
};

export const showExamples = () => {
  return (dispatch: Function, getState: () => RootState) => {
    getState().app.history.push('/examples');
  };
};

export const showLibrary = () => {
  return (dispatch: Function, getState: () => RootState) => {
    getState().app.history.push('/library');
  };
};

export const showAccountSettings = () => {
  return (dispatch: Function, getState: () => RootState) => {
    getState().app.history.push('/account');
  };
};

export const showBuyingOptions = (intent: string | undefined = undefined) => {
  return (dispatch: Function, getState: () => RootState) => {
    if (intent) {
      trackEvent('Prompt Upgrade', { intent });
    }
    const user = getState().app.user;
    if (user && user.isBlocked) {
      alert(
        "Can't use Pro features because already in use by another instance of the app."
      );
    } else {
      getState().app.history.push('/buy', { intent });
    }
  };
};

export const showAddCardFlow = () => {
  return (dispatch: Function, getState: () => RootState) => {
    getState().app.history.push('/buy', { intent: 'add-card' });
  };
};

export const updateUser = (data: User) => {
  return (dispatch: Function, getState: () => RootState) => {
    // const user = getState().app.user;
    // const wasPro = user && user.plan.startsWith('pro');
    dispatch({ type: UPDATE_USER, data });
    // if (wasPro && data.plan === 'free') {
    //   dispatch(
    //     showAlert(
    //       'Your account is not Pro anymore',
    //       'Looks like your subscription just ended. Please upgrade to use Pro features.',
    //       'Upgrade',
    //       () => {
    //         dispatch(showBuyingOptions());
    //       },
    //       'Not now'
    //     )
    //   );
    //   dispatch({ type: RESTORE_FREE_PLAN });
    // }
  };
};

export const blockUser = () => {
  return (dispatch: Function, getState: () => RootState) => {
    alert(
      'Your Pro account is already in use in another browser window or computer. Pro features will be disabled.'
    );
    dispatch({ type: BLOCK_USER });
  };
};

export const togglePlayback = () => {
  return {
    type: TOGGLE_PLAYBACK
  };
};

export const rewind = () => {
  return async (dispatch: Function, getState: () => RootState) => {
    dispatch({
      type: REWIND
    });
    await pause(1);
    document.dispatchEvent(new Event(TEMPLATE_PROPERTY_CHANGED));
  };
};

export const toggleAudioMute = () => {
  return async (dispatch: Function, getState: () => RootState) => {
    dispatch({
      type: TOGGLE_AUDIO_MUTE
    });
    const { soundtrack } = getState().flyer;
    if (soundtrack) {
      soundtrack.muted = getState().flyer.isMuted;
    }
  };
};

export const jumpPlayback = (time: number) => {
  return {
    type: JUMP_PLAYBACK,
    time
  };
};

export const browseEffects = () => {
  return {
    type: BROWSE_EFFECTS
  };
};

export const showEffectPreview = (
  layer: Layer,
  effectId: string,
  cachedData: any
) => {
  setValueInLocalStorage(ADDED_EFFECT_STORAGE_KEY, 'true');
  return async (dispatch: Function, getState: () => RootState) => {
    dispatch({
      type: SHOW_EFFECT_PREVIEW,
      layer,
      effectId,
      cachedData
    });
    if (effectId.startsWith('composition-')) {
      const duration = getState().flyer.motionSource.getDuration();
      dispatch(jumpPlayback(layer.getTimelineStart() * duration));
    }
  };
};

export const cancelEffectPreview = (layer: Layer) => {
  return {
    type: CANCEL_EFFECT_PREVIEW,
    layer
  };
};

// export const addPreviewedEffect = () => {
//   trackEvent('Add Effect', { id: previewedEffectId });
//   return {
//     type: ADD_PREVIEWED_EFFECT
//   };
// };

export const editedEffect = (effect: Effect | CompositionEffect) => {
  // re-render stage if it's not playing
  return async (dispatch: Function, getState: () => RootState) => {
    const { motionSource } = getState().flyer;
    dispatch({
      type: EDITED_EFFECT,
      effect
    });
    if (effect instanceof CompositionEffect) {
      const duration = motionSource.getDuration();
      dispatch(jumpPlayback(effect.layer.getTimelineStart() * duration));
    }
  };
};

export const editedText = (frame: Frame | null) => {
  return {
    type: EDITED_TEXT,
    frame
  };
};

export const editedSolidColor = () => {
  return {
    type: EDITED_SOLID_COLOR
  };
};

export const editedGradient = () => {
  return { type: EDITED_GRADIENT };
};

export const EDIT_SHAPE = 'EDIT_SHAPE';
export const editShape = (shapeContainer: ShapeFrame | Layer) => {
  return {
    type: EDIT_SHAPE,
    editedShape: shapeContainer
  };
};
export const CANCEL_EDIT_SHAPE = 'CANCEL_EDIT_SHAPE';
export const cancelEditShape = () => {
  return {
    type: CANCEL_EDIT_SHAPE
  };
};
export const CONFIRM_EDIT_SHAPE = 'CONFIRM_EDIT_SHAPE';
export const confirmEditShape = () => {
  return async (dispatch: Function, getState: () => RootState) => {
    const { editedShape: container, proposedEditedShape } = getState().app;
    if (container !== null && proposedEditedShape !== null) {
      const initialShape = container.mask;
      if (initialShape) {
        dispatch(
          new EditShapeCommand(container.id, initialShape, proposedEditedShape)
        );
      }
    }
  };
};

export const resetEffect = (effect: any) => {
  return {
    type: RESET_EFFECT,
    effect
  };
};

export const signInUser = (user: User) => {
  return async (dispatch: Function, getState: () => RootState) => {
    dispatch({
      type: USER_SIGN_IN,
      user
    });
    if (Sentry) {
      Sentry.configureScope((scope: any) => {
        scope.setUser({ email: user.email, id: user.uid });
      });
    }
    setValueInLocalStorage(LOG_STATUS_STORAGE_KEY, 'true');
    // // TODO: do it as side effect
    // const appState = getState().app;
    // if (appState.flowState === FlowState.Ready) {
    //   if (await saveLastVideoToUser(user.uid)) {
    //     await incrementVideoCounter(appState.recordType, user.uid);
    //     await decrementVideoCounter();
    //   }
    // }
  };
};

export const signOutUser = () => {
  return (dispatch: Function, getState: () => RootState) => {
    const appState = getState().app;
    const history = appState.history;
    if (
      history.location.pathname === '/account' ||
      history.location.pathname === '/library'
    ) {
      if (appState.user) {
        // the user intentionally logged out
        _goBack(history);
      } else {
        // the user likely landed here
        history.replace('/');
      }
    }
    dispatch({
      type: USER_SIGN_IN,
      user: null
    });
    setValueInLocalStorage(LOG_STATUS_STORAGE_KEY, 'false');
  };
};

export const addAudioFile = (
  file: File | string,
  thumbUrl: string | null = null,
  title: string | null = null,
  artist: string | null = null
) => {
  return openModal(ModalType.EditAudio, { file, thumbUrl, title, artist });
};

export const startLayerSplitting = (layer: Layer) => {
  return async (dispatch: Function, getState: () => RootState) => {
    if (!layer.frames.length) {
      alert('Strangely this layer has no frames, please report the issue');
      return;
    }
    for (const frame of layer.frames) {
      if (![FrameType.Image, FrameType.Video].includes(frame.type)) {
        alert('Only layers containing images or videos can be split');
        return;
      }
    }
    dispatch(openModal(ModalType.SplitLayer, layer));
  };
};

export const selectFrame = (frame: Frame | null) => {
  return async (dispatch: Function, getState: () => RootState) => {
    const { selectedFrame } = getState().app;
    if (frame === selectedFrame) {
      return;
    }
    const { layers } = getState().flyer;
    if (selectedFrame && selectedFrame !== frame) {
      selectedFrame.didUnselect();
      const parentLayer = layers
        .filter(layer => layer.frames.includes(selectedFrame))
        .shift();
      if (parentLayer) {
        const { compositionEffect } = parentLayer;
        if (compositionEffect && compositionEffect.isText) {
          // TODO: better way to make the effect dirty?
          compositionEffect.isTransitioning = true;
        }
      } else {
        reportBFError(
          new Error(
            'Cannot find the parent layer for the previously selected frame'
          )
        );
      }
    }
    for (const layer of layers) {
      layer.selectedFrame =
        frame && layer.frames.includes(frame) ? frame : null;
    }
    dispatch({
      type: SELECT_FRAME,
      frame
    });
  };
};

export const unselectFrame = () => {
  return selectFrame(null);
};

export const getOverlayColor = (
  resolution: Resolution,
  layer?: Layer
): string | string[] => {
  let color: string | string[] | undefined = undefined;
  if (layer && layer.frames.length) {
    for (let i = layer.frames.length - 1; i >= 0; i--) {
      const prevFrame = layer.frames[i];
      if (prevFrame.type === FrameType.Text) {
        color = (prevFrame as TextFrame).textStyle.fill as string | string[];
        break;
      }
      if (prevFrame.type === FrameType.SoundWave) {
        color = (prevFrame as SoundWaveFrame).sprite.getProperty('color');
        break;
      }
    }
  }
  if (!color) {
    const currentStageLuminosity = getStageLuminosity(
      resolution,
      getRenderer(),
      getStage()
    );
    color = currentStageLuminosity < 0.5 ? '#ffffff' : '#000000';
  }
  return color;
};

export const createTextFrame = async (
  app: AppState,
  flyer: FlyerState,
  isCaption: boolean,
  layer?: Layer
): Promise<Frame> => {
  const { lastEditedTextStyle } = app;
  const { resolution } = flyer;
  const padding = 10;
  const height = isCaption
    ? resolution.height * 0.5 - padding
    : resolution.height - padding * 2;
  const y = resolution.height - height - padding;
  const box = {
    x: padding,
    y,
    width: resolution.width - padding * 2,
    height
  };
  let textData: TextFrameData;
  const type = isCaption ? FrameType.Captions : FrameType.Text;
  const text = isCaption ? '' : 'Text';
  const verticalAlignment = isCaption
    ? TextAlignment.Bottom
    : TextAlignment.Middle;
  const size = isCaption ? 100 : 200;
  if (lastEditedTextStyle) {
    textData = {
      ...lastEditedTextStyle,
      type,
      text,
      box
    };
  } else {
    textData = {
      type,
      text,
      box,
      family: INITIAL_FONT.family,
      weight: INITIAL_FONT.weight,
      color: getOverlayColor(flyer.resolution, layer),
      alignment: [TextAlignment.Center, verticalAlignment],
      size,
      lineHeight: size,
      letterSpacing: 0,
      style: 'normal'
    };
  }
  let frame: TextFrame | CaptionsFrame;
  if (isCaption) {
    frame = new CaptionsFrame(resolution.width, resolution.height);
  } else {
    frame = new TextFrame(resolution.width, resolution.height);
  }
  frame.populateWithData(textData);
  await frame.load();
  frame.hasBeenEdited = false;
  return frame;
};

const checkIfCanAddCaptions = (soundtrack: Soundtrack | null) => {
  if (!soundtrack) {
    throw new Error('To add captions you need first to add a soundtrack.');
  }
  const durationsInSeconds = soundtrack.getDuration() / 1000;
  if (durationsInSeconds > MAX_CAPTIONS_DURATION) {
    throw new Error(
      `Captions are only available for audio not longer than ${MAX_CAPTIONS_DURATION} seconds`
    );
  }
};

export const addCaptions = (layer?: Layer) => {
  return async (dispatch: Function, getState: () => RootState) => {
    const { soundtrack } = getState().flyer;
    try {
      checkIfCanAddCaptions(soundtrack);
    } catch (error) {
      alert(error.message);
      return;
    }
    dispatch(new AddCaptionsFrameCommand(layer?.id));
  };
};

export const editCaptions = () => {
  return async (dispatch: Function, getState: () => RootState) => {
    const { soundtrack, captions, captionsLanguageCode } = getState().flyer;
    try {
      checkIfCanAddCaptions(soundtrack);
    } catch (error) {
      alert(error.message);
      return;
    }

    dispatch(
      openModal(ModalType.CaptionsEditing, {
        audioBuffer: soundtrack!.audioBuffer,
        initialTokens: captions || undefined,
        initialLanguageCode:
          captionsLanguageCode || getSpokenLanguage(getState().app.user)
      })
    );
  };
};

export const removeSoundtrack = () => {
  return async (dispatch: Function, getState: () => RootState) => {
    const { muteMotionSources, soundtrack, layers } = getState().flyer;
    muteMotionSources.forEach(s => {
      s.soundtrackDuration = 0;
    });
    soundtrack?.dispose();
    layers.forEach(l => {
      l.frames.forEach(frame => {
        if (frame instanceof CaptionsFrame) {
          frame.tokens = [];
        }
      });
      l.effects.forEach(f => {
        if (!f.isSplitEffect) {
          if (f.signalSource) {
            if (isSoundtrackSignal(f.signalSource)) {
              f.signalSource = SignalSource.Default;
            }
          } else {
            reportBFError(
              new Error(
                `Effect ${(f.constructor as any).id} doesn't have signalSource`
              )
            );
          }
        }
      });
    });
    dispatch({ type: REMOVE_SOUNDTRACK });
  };
};

export const addLocalGraphics = (
  files: File[],
  layer: Layer | null = null,
  scaleUp: boolean = false,
  fitSize: PointData | null = null
) => {
  return async (dispatch: Function, getState: () => RootState) => {
    const { soundtrack, layers } = getState().flyer;
    if (
      getState().app.importDesign &&
      layers.length === 0 &&
      files.length === 1
    ) {
      const file = await resizeImageFileIfNecessary(files[0]);
      const url = URL.createObjectURL(file);
      const img = await loadImage(url);
      URL.revokeObjectURL(url);

      let resolution: Resolution = {
        width: 1080,
        height: 1080,
        name: 'custom'
      };

      const maxSize = 1920;
      if (img.width > maxSize || img.height > maxSize) {
        if (img.width > maxSize) {
          const hRatio = img.height / img.width;
          resolution.width = maxSize;
          resolution.height = Math.floor(hRatio * maxSize);
        } else {
          const wRatio = img.width / img.height;
          resolution.height = maxSize;
          resolution.width = Math.floor(wRatio * maxSize);
        }
      } else {
        resolution.width = img.width;
        resolution.height = img.height;
      }

      const currentResolution = getState().flyer.resolution;
      if (
        resolution.width !== currentResolution.width ||
        resolution.height !== currentResolution.height
      ) {
        dispatch(new EditResolutionCommand(resolution));
        await pause(1);
      }
      dispatch(new AddPictureFrameCommand(undefined, file, false, null, false));
    } else {
      for (let i = 0; i < files.length; i++) {
        if (i > 0) {
          // add pause to make sure layers are added in the right order. Because the command load the frame before adding them, they might load at a different time.
          await pause(100);
        }
        dispatch(
          new AddPictureFrameCommand(
            layer?.id,
            files[i],
            scaleUp,
            fitSize,
            files.length === 1
          )
        );
      }
    }

    const videoFiles = files.filter(f => {
      return f.type.split('/')[0] === 'video';
    });
    if (videoFiles.length === 1) {
      const videoFile = videoFiles[0];
      const audioFile = await extractAudioFileFromVideo(videoFile);
      if (audioFile) {
        let addSoundtrack = true;
        if (soundtrack) {
          addSoundtrack = confirm(
            `The video you are adding has an audio track, would you like to use this as new soundtrack?`
          );
          if (addSoundtrack) {
            dispatch(new RemoveSoundtrackCommand());
            await pause(1);
          }
        }
        if (addSoundtrack) {
          const newSoundtrack = new Soundtrack(false);
          newSoundtrack.title = videoFile.name;
          await newSoundtrack.load(audioFile);
          dispatch(new AddSoundtrackCommand(newSoundtrack));
        }
      }
    }
  };
};

export const addRemoteGraphics = (url: string) => {
  return async (dispatch: Function, getState: () => RootState) => {
    try {
      // fix the caches issue between Chrome and S3
      if (url.includes('?')) {
        url += `&rand=${Date.now()}`;
      } else {
        url += `?rand=${Date.now()}`;
      }
      const blob = await loadFile(url);
      if (
        ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'].indexOf(
          blob.type
        ) > -1
      ) {
        const ext = blob.type.split('/').pop();
        const file = new File([blob], `image.${ext}`);
        dispatch(addLocalGraphics([file]));
      } else {
        alert(`File of type "${blob.type}" is not supported`);
      }
    } catch (err) {
      alert(
        `Could not load the file, make sure the file has the correct access policy.`
      );
    }
  };
};

export const addLayers = (layers: Layer[]) => {
  return {
    type: ADD_LAYERS,
    layers
  };
};

export const removeLayer = (layer: Layer) => {
  return {
    type: REMOVE_LAYER,
    layer
  };
};

export const restoreLayer = (layer: Layer, index: number) => {
  return {
    type: RESTORE_LAYER,
    layer,
    index
  };
};

export const removeFrameOrLayer = (frame: Frame) => {
  return async (dispatch: Function, getState: () => RootState) => {
    const { layers } = getState().flyer;
    for (const layer of layers) {
      if (layer.frames.includes(frame)) {
        if (layer.frames.length > 1) {
          dispatch(new RemoveFrameCommand(frame.id));
        } else {
          dispatch(new RemoveLayerCommand(layer.id));
        }
        return;
      }
    }
  };
};

export const removeFrame = (frame: Frame) => {
  return async (dispatch: Function, getState: () => RootState) => {
    // find if the layer containing the frame has multiple frames, otherwise remove the whole layer
    const { layers } = getState().flyer;
    layers.forEach(l => {
      if (l.frames.includes(frame)) {
        if (l.frames.length > 1) {
          dispatch({
            type: REMOVE_FRAME,
            layer: l,
            frame
          });
        } else {
          dispatch(removeLayer(l));
        }
      }
    });
  };
};

export const rejectRecording = () => {
  return {
    type: RECORDING_STOPPED
  };
};

export const didDownloadRecording = () => {
  return {
    type: VIDEO_DOWNLOAD_ENDED
  };
};
/*
export const convertRecording = (blob: Blob | null = null) => {
  return async (dispatch: Function, getState: () => RootState) => {
    const appState: AppState = getState().app;
    if (!blob) {
      blob = appState.recordingBlob!;
    }
    if (!blob) {
      throw new Error('Recording blob is missing');
    }
    invariant(blob.type === FileType.webm, 'Can only convert webm videos');
    const file = new File([blob], 'video.webm');
    const flyerState = getState().flyer;
    let effectsCount = 0;
    flyerState.layers.forEach(layer => {
      effectsCount += layer.visibleEffectsCount;
    });
    const duration = flyerState.motionSource.getVideoDuration();
    dispatch({
      type: PREPARING_VIDEO_UPLOAD
    });
    const type = RecordType.VideoAsync;
    const filename = await getAvailableFilename(type);
    const resultFilename =
      filename + (type.startsWith('video') ? '.mp4' : '.gif');
    dispatch({
      type: UPLOAD_VIDEO
    });
    let hasUploadedThumbnail = false;
    let hasUploadedFile = false;
    let hasConvertedFile = false;
    try {
      await uploadFile(
        filename + '.jpg',
        appState.videoThumbnail!,
        FileType.jpg
      );
      hasUploadedThumbnail = true;
      await uploadFile(filename, file, FileType.webm, (progress: number) => {
        // dispatch({
        //   type: UPLOAD_VIDEO_PROGRESSED,
        //   progress
        // });
      });
      hasUploadedFile = true;
      // dispatch({
      //   type: PREPARING_VIDEO_CONVERSION
      // });
      const params = generateConversionParams(bucketInternalBaseUrl + filename);
      const jobInfo = await MediaConvert.createJob(params).promise();
      const jobId = jobInfo.Job?.Id;
      console.log('Job Id: ' + jobId);
      // dispatch({
      //   type: STARTED_VIDEO_CONVERSION
      // });
      hasConvertedFile = await waitForJobCompletion(jobId!);
      if (hasConvertedFile) {
        const url = getBaseURL() + resultFilename;
        // const resultFile = await loadFile(url);
        dispatch({
          type: RECORDING_READY,
          blob: null,
          url
        });
        const folder = type.startsWith('video') ? 'videos' : 'gifs';
        const size = (await getFileSize(url)) / 1000;
        await addUserVideo(
          appState.user ? appState.user.uid : null,
          folder,
          filename,
          flyerState.layers.length,
          effectsCount,
          duration,
          size
        );
        console.log('added new video');
        // incrementVideoCounterIfNeeded(dispatch, appState);
      }
    } catch (e) {
      reportIssue('Failed to convert video in the cloud');
      reportBFError(e);
      dispatch({
        type: SHOW_ALERT,
        alert: {
          title: 'Conversion error',
          text:
            'Something went wrong while converting your video, please try to record it again.' +
            (isElectronApp()
              ? ' If the problem persists, please let us know.'
              : ' If the problem persists, please use the desktop app: https://beatflyer.com/download/'),
          okButton: 'Ok',
          okCallback: () => {
            dispatch(rejectRecording());
          }
        }
      });
      if (hasUploadedThumbnail) {
        await deleteFile(filename + '.jpg');
        console.log('thumbnail deleted');
      }
      if (hasConvertedFile) {
        await deleteFile(resultFilename);
        console.log('converted file deleted');
      }
    } finally {
      if (hasUploadedFile) {
        await deleteFile(filename);
        console.log('original file deleted');
      }
    }
  };
};
*/
// export const recordingCompleted = (blob: Blob) => {
//   return (dispatch: Function, getState: () => RootState) => {
//     const appState = getState().app;
//     if (appState.isFigmaPlugin) {
//       dispatch({
//         type: RECORDING_READY,
//         blob
//       });
//       return;
//     }
//     if (!smooth && !isElectronApp()) {
//       // show review step
//       dispatch({
//         type: RECORDING_NOT_SMOOTH,
//         blob
//       });
//     } else {
//       if (blob.type === FileType.webm) {
//         dispatch(convertRecording(blob));
//       } else {
//         dispatch({
//           type: RECORDING_READY,
//           blob
//         });
//       }
//     }
//   };
// };

const onRecordReady = (recordType: RecordType, url: string, fps?: number) => {
  return async (dispatch: Function, getState: () => RootState) => {
    if (!isUrlBlob(url)) {
      // save
      const filename = url.split('/').pop()?.split('.')[0]!;
      await uploadFile(
        filename + '.jpg',
        getState().app.videoThumbnail!,
        FileType.jpg
      );
      const folder = recordType === RecordType.GIF ? 'gifs' : 'videos';
      getStageBackground().visible = true;
      const size = (await getFileSize(url)) / 1000;
      const flyerState = getState().flyer;
      let effectsCount = 0;
      flyerState.layers.forEach(layer => {
        effectsCount += layer.visibleEffectsCount;
      });
      const duration = flyerState.motionSource.getDuration();
      await addUserVideo(
        getState().app.user?.uid || null,
        folder,
        filename,
        flyerState.layers.length,
        effectsCount,
        duration,
        size
      );
    }
    if (!getState().flyer.soundtrack) {
      // TODO: unlock audio with this workaround: https://stackoverflow.com/questions/54047606/allow-audio-play-on-safari-for-chat-app
      try {
        const snd = new Audio('/media/finish.mp3'); // buffers automatically when created
        await snd.play();
      } catch {
        console.warn(
          'Could not play finish sound, probably Safari blocked it.'
        );
      }
    }
    dispatch({
      type: RECORDING_READY,
      recordType,
      url,
      smoothness:
        fps !== undefined ? getSmoothness(fps) : PlaybackSmoothness.Smooth
    });
    if (getState().app.isCloudRenderer) {
      download(url);
    }
  };
};

export const startRecording = (
  recordType: RecordType,
  options: IRecordingOptions | null = null
) => {
  return async (dispatch: Function, getState: () => RootState) => {
    const appState = getState().app;
    const { isBeatflyerLite, isCloudRenderer, platform } = appState;
    const { resolution, motionSource, soundtrack, originTemplateId, layers } =
      getState().flyer;
    if (
      !canRecordVideo() &&
      !isBeatflyerLite &&
      platform !== PlatformType.iOSApp
    ) {
      alert(
        'Your browser cannot record video. Please consider using Google Chrome or our desktop application'
      );
      return;
    }
    if (
      isBeatflyerLite &&
      !isFigmaPro(appState) &&
      (resolution.width % 2 > 0 || resolution.height % 2 > 0)
    ) {
      alert(
        'Please make sure both your artboard width and height are multiple of 2'
      );
      return;
    }
    // take video screenshot
    // const motionSource = this.props.motionSource;
    // motionSource.pause();
    // this.resetFilters();
    // // reset layers with videos
    // await Promise.all(
    //   this.layers.map(layer => {
    //     return layer.play(0);
    //   })
    // );
    const renderer = getRenderer();
    const videoThumbnail = await getStageScreenshotFile(
      resolution,
      renderer,
      getStage()
    );

    if (isCloudRenderer) {
      download(videoThumbnail, 'thumbnail.jpg');
    }

    const visibleLayers = layers.filter(l => l.visible);

    // debugImage(URL.createObjectURL(videoThumbnail)); // debug thumbnail

    if (recordType === RecordType.Video) {
      recordType = RecordType.VideoLive;
      const canRecordAsync =
        canRecordVideoAsync() ||
        platform === PlatformType.iOSApp ||
        isBeatflyerLite ||
        isCloudRenderer;
      if (canRecordAsync && options?.forceRealtimeRecording !== true) {
        recordType = RecordType.VideoAsync;
      }
      if (
        recordType === RecordType.VideoAsync &&
        visibleLayers.some(l => l.frames[0].type === FrameType.Video)
      ) {
        recordType = RecordType.VideoLive;
      }
    }
    console.log('start recording: ' + recordType);

    if (appState.user && appState.lastUserUpdate + 60 * 1000 < Date.now()) {
      const data = await loadUser(appState.user.uid);
      dispatch(updateUser(data));
    }

    let recorder: Recorder | undefined = undefined;
    let duration = (soundtrack || motionSource).getDuration();

    switch (recordType) {
      case RecordType.GIF: {
        if (options?.transparentBackground) {
          getStageBackground().visible = false;
        }
        // reset (hide) composition effects
        visibleLayers.forEach(layer => {
          layer.compositionEffect?.reset();
        });
        const gifDuration = (60 / motionSource.bpm) * 1000;
        const framesNumber = Math.ceil((gifDuration / 1000) * GIF_FPS);
        const gRecorder = new GIFRecorder(
          renderer.view,
          resolution.width,
          resolution.height,
          framesNumber,
          gifDuration,
          options?.transparentBackground
        );
        recorder = gRecorder;
        break;
      }
      case RecordType.VideoLive: {
        motionSource.reset();
        const videoRecorder = new VideoRecorder(
          renderer.view,
          soundtrack,
          duration
        );
        motionSource.play();
        // const shouldFadeAudio: boolean =
        //   motionSource.hasAudio &&
        //   (motionSource as Soundtrack).audioFadeLength > 0;
        videoRecorder.record(false);
        recorder = videoRecorder;
        break;
      }
      case RecordType.VideoAsync: {
        let offlineFrequencies: Uint8Array[] | null = null;
        let offlineWaveforms: Uint8Array[] | null = null;
        if (motionSource.hasAudio) {
          dispatch(
            openModal(ModalType.Processing, 'Processing audio', false, true)
          );
          const buffer = (motionSource as Soundtrack).audioBuffer;
          offlineFrequencies = await sampleBuffer(buffer);
          offlineWaveforms = await getWaveformsFromBuffer(buffer);
        }
        if (isBeatflyerLite && !isFigmaPro(appState)) {
          const h264Recorder = new H264AsyncRecorder(
            renderer.view,
            Math.ceil((motionSource.getDuration() / 1000) * VIDEO_FPS),
            duration
          );
          await h264Recorder.createEncoder();
          recorder = h264Recorder;
        } else if (isElectronApp()) {
          recorder = new ElectronRecorder(
            renderer.view,
            Math.ceil((motionSource.getDuration() / 1000) * VIDEO_FPS),
            duration,
            soundtrack ? soundtrack.audioBuffer : null,
            0,
            offlineFrequencies,
            offlineWaveforms
          );
        } else if (platform === PlatformType.iOSApp) {
          recorder = new IosRecorder(
            renderer.view,
            Math.ceil((motionSource.getDuration() / 1000) * VIDEO_FPS),
            duration,
            soundtrack ? soundtrack.audioBuffer : null,
            offlineFrequencies,
            offlineWaveforms
          );
        } else {
          let audioSource: AudioBuffer | string | null = null;
          if (soundtrack) {
            audioSource = soundtrack.url || soundtrack.audioBuffer;
            console.log('Audio url: ' + audioSource);
          }
          const asyncRecorder = new BrowserAsyncRecorder(
            renderer.view,
            Math.ceil((motionSource.getDuration() / 1000) * VIDEO_FPS),
            duration,
            audioSource,
            offlineFrequencies,
            offlineWaveforms
          );
          recorder = asyncRecorder;
        }
        break;
      }
      default:
        break;
    }

    if (recorder) {
      recorder.once(RecorderEvent.RecordingEnded, () => {
        dispatch({
          type: RECORDING_ENDED
        });
      });
      recorder.once(RecorderEvent.Complete, (url: string, fps?: number) => {
        dispatch(onRecordReady(recordType, url, fps));
      });
    }

    dispatch({
      type: START_RECORDING,
      recorder,
      videoThumbnail
    });

    const numLayers = visibleLayers.length;
    const numEffects = visibleLayers.reduce(
      (tot: number, layer: Layer): number => {
        return tot + layer.effects.filter(fx => fx.visible).length;
      },
      0
    );

    trackEvent('Record flyer', {
      type: recordType,
      numLayers,
      numEffects,
      hasAudio: soundtrack !== null,
      templateId: originTemplateId || undefined,
      resolution: sizeToString(resolution)
    });
    await incrementVideoCounter(recordType, appState.user?.uid || null);
    // TODO: check visibility
  };
};

export const cancelRecording = () => {
  return async (dispatch: Function, getState: () => RootState) => {
    console.log('cancel recording');
    // block current update pipeline
    const { layers } = getState().flyer;
    layers.forEach(layer => {
      if (layer.isVideo) {
        const video = (layer.frames[0] as PictureFrame).texture!.baseTexture
          .source as HTMLVideoElement;
        video.onseeked = null;
      }
    });
    getStageBackground().visible = true;
    const { recorder } = getState().app;
    if (recorder) {
      const motionSource = getState().flyer.motionSource;
      recorder.removeAllListeners(RecorderEvent.Complete);
      recorder.cancel();
      motionSource?.resume();
    }
    dispatch({
      type: RECORDING_STOPPED
    });
  };
};

export const pageWillEnterBackground = () => {
  return async (dispatch: Function, getState: () => RootState) => {
    const { recorder, isBeatflyerLite, platform } = getState().app;
    if (isBeatflyerLite) {
      return;
    }
    if (recorder) {
      if (
        recorder.type === RecordType.VideoLive ||
        platform === PlatformType.iOSApp
      ) {
        dispatch(cancelRecording());
        const context = platform === PlatformType.Web ? 'browser tab' : 'app';
        dispatch(
          showAlert(
            new Alert(
              'The recording was cancelled',
              `When recording, please keep the ${context} in the foreground.`
            )
          )
        );
      } else {
        // ignore
        return;
      }
    }
    dispatch({
      type: APP_WILL_ENTER_BACKGROUND
    });
  };
};

export const pageDidEnterForeground = () => {
  return async (dispatch: Function, getState: () => RootState) => {
    const { isBeatflyerLite } = getState().app;
    if (isBeatflyerLite) {
      return;
    }
    dispatch({
      type: APP_DID_ENTER_FOREGROUND
    });
  };
};

// const incrementVideoCounterIfNeeded = (
//   dispatch: Function,
//   appState: AppState
// ) => {
//   if (!appState.hasDownloadedRecording) {
//     const user = appState.user;
//     const type = appState.recordType;
//     incrementVideoCounter(type, user ? user.uid : null).then((data: User) => {
//       if (user) {
//         dispatch(updateUser(data));
//       }
//     });
//     trackEvent(
//       'Flyer Download',
//       'Donloaded ' + (type.startsWith('video') ? 'Video' : 'Gif')
//     );
//     dispatch(didDownloadRecording());
//   }
// };

// export const recordingEnded = (smooth: boolean = true) => {
//   return {
//     type: RECORDING_COMPLETED,
//     smooth
//   };
// };

// export const continueWithUnsmoothRecording = () => {
//   return (dispatch: Function, getState: () => RootState) => {
//     const blob = getState().app.recordingBlob!;
//     if (blob.type === FileType.webm) {
//       dispatch(convertRecording());
//     } else {
//       dispatch({
//         type: RECORDING_READY,
//         blob
//       });
//     }
//   };
// };

/*
export const downloadRecording = () => {
  return async (dispatch: Function, getState: () => RootState) => {
    const appState: AppState = getState().app;
    let blob = appState.recordingBlob;
    if (!blob) {
      invariant(
        appState.recordingURL !== null,
        'Both recording blob and URL are missing'
      );
      download(appState.recordingURL!);
    } else {
      const ext = blob.type.split('/').pop() as string;
      if (appState.isFigmaPlugin) {
        download(blob, 'flyer.' + ext, blob.type);
        return;
      }
      invariant(blob.type !== FileType.webm, 'Cannot download a webm video');
      if (blob.type === FileType.gif) {
        if (appState.recordingBlobCompressed) {
          blob = appState.recordingBlobCompressed;
        } else {
          dispatch({ type: WILL_COMPRESS_RECORDING });
          try {
            const compressedBlob = await compressGIF(blob);
            if (compressedBlob) {
              blob = compressedBlob;
              dispatch({ type: DID_COMPRESS_RECORDING, blob });
            } else {
              reportIssue("GIF couldn't be compressed");
            }
          } catch (e) {
            reportBFError(e);
            dispatch({ type: DID_COMPRESS_RECORDING, blob: undefined });
          }
        }
      }
      download(blob, 'flyer.' + ext, blob.type);
    }
    // incrementVideoCounterIfNeeded(dispatch, appState);
  };
};
*/
export const shareVideo = (url: string) => {
  return async (dispatch: Function, getState: () => RootState) => {
    const duration = getState().flyer.motionSource.getDuration();
    if (duration >= 5 * 60 * 1000) {
      // 5 minutes
      alert(
        `Currently it is not possible to share via mobile app videos longer than 5 minutes.`
      );
      return;
    }
    const { user } = getState().app;
    if (!user) {
      alert('User should be available');
      return;
    }
    await saveLastVideoToUser(user.uid);
    dispatch(openModal(ModalType.ShareVideo, url, true));
    if (user.segmentationSurvey === undefined) {
      dispatch(openModal(ModalType.SegmentationSurvey, false, true));
    }
  };
};
/*
export const shareVideo = () => {
  return async (dispatch: Function, getState: () => RootState) => {
    const appState = getState().app;
    if (!appState.user) {
      dispatch(
        showAlert(
          new Alert(
            'Sign in to share',
            'Please sign in or register to share a video',
            'Sign in',
            () => {
              openSignInWindow();
            },
            'Cancel'
          )
        )
      );
      return;
    }
    const blob = appState.recordingBlob!;
    invariant(blob.type === FileType.mp4, 'Can only upload mp4 videos');
    const file = new File([blob], 'video.webm');
    const flyerState = getState().flyer;
    let effectsCount = 0;
    flyerState.layers.forEach(layer => {
      effectsCount += layer.visibleEffectsCount;
    });
    const duration = flyerState.motionSource.getVideoDuration();
    const filename = await getAvailableFilename(RecordType.VideoAsync);
    dispatch({
      type: UPLOAD_VIDEO
    });
    await uploadFile(filename + '.jpg', appState.videoThumbnail!, FileType.jpg);
    await uploadFile(
      filename + '.mp4',
      file,
      FileType.mp4,
      (progress: number) => {
        dispatch({
          type: UPLOAD_VIDEO_PROGRESSED,
          progress
        });
      }
    );
    await addUserVideo(
      appState.user!.uid,
      'videos',
      filename,
      flyerState.layers.length,
      effectsCount,
      duration,
      blob.size / 1000
    );
    dispatch({
      type: VIDEO_SHARED
    });
    // incrementVideoCounterIfNeeded(dispatch, appState);
  };
};
*/

const updateToEffectsSignal = (data: FlyerData, hasAudio: boolean) => {
  if (data.layers) {
    for (const layer of data.layers) {
      if (layer.audioSource !== undefined && hasAudio && layer.effects) {
        const layerSignalSource = AUDIO_SOURCE_IDS[
          layer.audioSource
        ] as SignalSource;
        for (const effect of layer.effects) {
          effect.signalSource = effect.signalSource || layerSignalSource;
        }
      }
    }
  }
};

export const loadExample = (id: string) => {
  setValueInLocalStorage(INTRO_STORAGE_KEY, 'true');
  trackEvent('Load example', { id });
  return async (dispatch: Function, getState: () => RootState) => {
    dispatch({
      type: WILL_LOAD_EXAMPLE
    });
    const exampleData: FlyerData = (await getExamples()).filter(item => {
      return item.id === id;
    })[0];
    const hasAudio = exampleData.audio !== undefined && canBrowserPlayAudio();
    updateToEffectsSignal(exampleData, hasAudio);
    // console.log('load...');
    // console.log( exampleData );
    const flyerType: FlyerType = exampleData.type || FlyerType.Example;
    const resolution = exampleData.resolution;
    const pixelRatio = getState().flyer.previewPixelRatio.value;
    const layers = exampleData.layers!.map((data: any): Layer => {
      const layer: Layer = new Layer();
      layer.populateFromObj({
        ...data,
        stageWidth: resolution.width * pixelRatio,
        stageHeight: resolution.height * pixelRatio,
        pixelRatio: getState().flyer.previewPixelRatio.value
      });
      return layer;
    });
    for (const layer of layers) {
      await layer.load();
    }
    if (exampleData.audio !== undefined && canBrowserPlayAudio()) {
      const soundtrack = new Soundtrack(true);
      try {
        await soundtrack.load(exampleData.audio);
        dispatch({
          type: LOAD_EXAMPLE,
          flyerType,
          layers,
          soundtrack,
          motionSource: soundtrack,
          resolution,
          autoPlay: getState().app.userHasInteractedWithPage,
          templateUIIntro: exampleData.templateUIIntro
        });
      } catch (e) {
        console.log(e);
      }
    } else {
      dispatch({
        type: LOAD_EXAMPLE,
        flyerType,
        layers,
        motionSource: new BeatMotionSource(),
        resolution,
        autoPlay: true,
        templateUIIntro: exampleData.templateUIIntro
      });
    }
    // if (layers.some(l => l.frames[0]!.type === FrameType.Video)) {
    //   showLiveRecordingAlert();
    // }
  };
};

interface MotionSourceLoadResult {
  motionSource: MotionSource;
  soundtrack: Soundtrack | null;
}

const loadMotionSource = async (
  data: StorableMotionData
): Promise<MotionSourceLoadResult> => {
  let soundtrack: Soundtrack | null = null;
  let mutedMotionSource: MuteMotionSource | null = null;
  if (data.audioUrl) {
    soundtrack = new Soundtrack(true);
    soundtrack.thumbUrl = data.audioThumbUrl || null;
    soundtrack.title = data.audioTitle || null;
    soundtrack.artist = data.audioArtist || null;
    await soundtrack.load(data.audioUrl);
  }
  if (data.motionSource) {
    mutedMotionSource = new BeatMotionSource();
    const motionType = data.motionSource.type;
    switch (motionType) {
      case MotionSourceType.Binary:
        mutedMotionSource = new BinaryMotionSource();
        break;
      case MotionSourceType.LinearLoop:
        mutedMotionSource = new LinearLoopMotionSource();
        break;
      case MotionSourceType.FullOn:
        mutedMotionSource = new FullOnMotionSource();
        break;
      default:
        break;
    }
    mutedMotionSource.populateWithData(data.motionSource);
  } else if (data.curve) {
    mutedMotionSource = new BeatMotionSource();
    mutedMotionSource.populateWithData(data.curve);
  }
  if (!soundtrack && !mutedMotionSource) {
    mutedMotionSource = new BeatMotionSource();
  }
  if (mutedMotionSource && soundtrack) {
    mutedMotionSource.soundtrackDuration = soundtrack.getDuration();
  }
  return {
    motionSource: mutedMotionSource || soundtrack!,
    soundtrack
  };
};

export const loadFlyer = (flyerId: string, isTemplate: boolean = false) => {
  return async (dispatch: Function, getState: () => RootState) => {
    dispatch({
      type: WILL_LOAD_EXAMPLE
    });
    const flyer = await getFlyer(flyerId, isTemplate);
    if (!flyer) {
      // prevents reloading of opened flyers which have just been deleted
      window.location.hash = '';
      getState().app.history.replace('/');
      dispatch({
        type: RESET
      });
      return;
    }
    flyer.id = flyerId;
    const hasAudio = flyer.audioUrl !== undefined && canBrowserPlayAudio();
    updateToEffectsSignal(flyer, hasAudio);
    // preload images
    // await preloadUrls(getAllImagesUrl(flyer));
    // const user = getState().app.user;
    // if (user && user.email === RENDERER_EMAIL) {
    //   // preload videos
    //   await preloadUrls(getAllVideosUrl(flyer));
    // }
    let resolution = flyer.resolution;
    if (!resolution) {
      alert(
        'The file you are trying to load is corrupted. The team has been notified and will reach out for discussing the matter. We are depply sorry!'
      );
      reportBFError(new Error('Flyer corrupted: ' + flyerId));
      return;
    }
    resolution = matchResolutionWithStandards(resolution) || resolution;
    const flyerType = isTemplate ? FlyerType.Template : FlyerType.Own;
    const pixelRatio = getState().flyer.previewPixelRatio.value;
    let layers: Layer[] = [];
    const customFontNames = new Set<string>();
    if (flyer.layers) {
      layers = flyer.layers.map(data => {
        const layer: Layer = new Layer();
        data.frames.forEach(f => {
          if ('family' in f) {
            const fontFamily = (f as TextFrameData).family;
            if (isCustomFont(fontFamily)) {
              customFontNames.add(cleanCustomFontName(fontFamily));
            }
          }
        });
        layer.populateFromObj({
          ...data,
          stageWidth: resolution.width * pixelRatio,
          stageHeight: resolution.height * pixelRatio,
          pixelRatio: getState().flyer.previewPixelRatio.value
        });
        return layer;
      });
    }
    if (flyer.uid && customFontNames.size > 0) {
      const { user } = getState().app;
      if (user?.uid === undefined || flyer.uid !== user.uid) {
        let customFonts = await getUserCustomFonts(flyer.uid);
        const usedFonts = customFonts.filter(f => customFontNames.has(f.name));
        await Promise.all(usedFonts.map(f => loadCustomFont(f)));
      }
    }
    for (const layer of layers) {
      await layer.load();
    }
    const {
      id,
      name,
      date,
      templateUI,
      templateOptions,
      templateUIIntro,
      captions,
      captionsLanguageCode
    } = flyer;
    if (captions) {
      layers.forEach(layer => {
        layer.frames.forEach(frame => {
          if (frame instanceof CaptionsFrame) {
            frame.tokens = captions;
          }
        });
      });
    }
    const motionSourceResult = await loadMotionSource(flyer);
    const autoPlay =
      (!motionSourceResult.soundtrack ||
        getState().app.userHasInteractedWithPage) &&
      !isTemplate;
    dispatch({
      ...motionSourceResult,
      type: LOAD_EXAMPLE,
      id,
      name,
      flyerType,
      layers,
      resolution,
      autoPlay,
      lastSave: date,
      templateUI: isTemplate ? null : templateUI,
      templateOptions: isTemplate ? null : templateOptions,
      templateUIIntro,
      captions,
      captionsLanguageCode
    });
    if (getState().app.isCloudRenderer) {
      dispatch(startRecording(RecordType.Video));
    }
  };
};

export const createNew = () => {
  window.location.hash = '';
  return {
    type: RESET
  };
};

// export const addFrameWithImage = (
//   layer: Layer,
//   file: File,
//   backgroundStyle: BackgroundStyle
// ) => {
//   return {
//     type: ADD_FRAME,
//     layer,
//     file,
//     frameType: FrameType.Image,
//     backgroundStyle
//   };
// };

export const promptAddFrame = (type: FrameType, layer?: Layer) => {
  //
};

// export const addFrame = (layer: Layer, file: File) => {
//   return async (dispatch: Function, getState: () => RootState) => {
//     const backgroundStyle = await getBackgroundStyleFromImageFile(file);
//     dispatch(addFrameWithImage(layer, file, backgroundStyle));
//   };
// };

export const changeResolution = (resolution: Resolution) => {
  trackEvent('Change Resolution', resolution);
  return {
    type: CHANGE_RESOLUTION,
    resolution
  };
};

export const changePreviewPixelRatio = (pixelRatio: PixelRatio) => {
  return {
    type: CHANGE_PREVIEW_PIXELRATIO,
    pixelRatio
  };
};

export const assignLoop = (loop: Loop) => {
  trackEvent('Load music loop', { url: loop.audio });
  return (dispatch: Function) => {
    if (loop.shouldEdit) {
      dispatch(
        addAudioFile(loop.audio, loop.thumb, loop.name, loop.artist || null)
      );
    } else {
      const soundtrack = new Soundtrack(true);
      soundtrack.thumbUrl = loop.thumb;
      soundtrack.title = loop.name;
      soundtrack.artist = loop.artist || null;
      soundtrack.load(loop.audio).then(() => {
        dispatch(new AddSoundtrackCommand(soundtrack));
      });
    }
  };
};

export const addResolution = (resolution: Resolution) => {
  return async (dispatch: Function, getState: () => RootState) => {
    const uid = getState().app.user!.uid;
    await addCustomResolution(uid, resolution);
    const data = await loadUser(uid);
    dispatch(updateUser(data));
    dispatch(closeModal());
    const user = getState().app.user!;
    for (let i = 0; i < user.customResolutions.length; i++) {
      const r = user.customResolutions[i];
      if (r.width === resolution.width && r.height === resolution.height) {
        dispatch(new EditResolutionCommand(r));
        break;
      }
    }
  };
};

// export const updateUserFromDB = async (uid: string, dispatch: Function) => {
//   const data = await loadUser(uid);
//   dispatch({ type: UPDATE_USER, data });
// };

export const userDidInteract = () => {
  getAudioContext().resume();
  return {
    type: USER_DID_INTERACT
  };
};

export const loadFigmaLayers = (
  width: number,
  height: number,
  layers: Uint8Array[] | string[],
  showIntro: boolean,
  bgColor: string | undefined = undefined,
  layersData: LayerData[] | undefined = undefined,
  motionData: FlatStorableMotionData | undefined = undefined
) => {
  return async (dispatch: Function, getState: () => RootState) => {
    const { flyer } = getState();
    // change stage size
    let index = 0;
    dispatch(userDidInteract());
    dispatch(changeResolution({ name: 'figma', width, height }));
    // await timeoutPromise(1000);
    if (bgColor) {
      const bgFrame = new SolidFrame(width, height);
      const data: SolidFrameData = {
        type: FrameType.SolidColor,
        color: bgColor
      };
      bgFrame.populateWithData(data);
      dispatch({
        type: ADD_FRAME,
        frame: bgFrame
      });
    }
    while (layers.length) {
      const layerImage = layers.shift();
      const layerData =
        layersData !== undefined ? layersData.shift() : undefined;
      let url: string = '';
      if (typeof layerImage === 'string') {
        url = 'data:image/png;base64,' + layerImage;
      } else {
        const base64Data = btoa(
          (layerImage as Uint8Array).reduce((data: any, byte: any) => {
            return data + String.fromCharCode(byte);
          }, '')
        );
        url = 'data:image/png;base64,' + base64Data;
      }
      const layer = new Layer();
      layer.id = layerData?.id ?? layer.id;
      layer.setStageSize(
        width * flyer.previewPixelRatio.value,
        height * flyer.previewPixelRatio.value
      );
      const file = dataURLtoFile(url, `image+${index++}.png`);
      const box: RectData = (layerData as any)?.box ?? {
        x: 0,
        y: 0,
        width,
        height
      };
      const frame = new PictureFrame(box.width, box.height);
      frame.boundingBox = new PIXI.Rectangle(
        box.x,
        box.y,
        box.width,
        box.height
      );
      frame.file = file;
      frame.filename = file.name;
      frame.type = FrameType.Image;
      frame.backgroundStyle = await getBackgroundStyleFromImageFile(file);
      layer.addFrame(frame);
      if (layerData) {
        layer.applySettings(layerData);
        if (layerData.timeline) {
          const keys = Object.keys(layerData.timeline);
          for (const key of keys) {
            layer.timeline[key] = PropertyTimeline.createFromData(
              layerData.timeline[key]
            );
          }
        }
        if (layerData.compositionEffect) {
          const effect = CompositionEffect.createCompositionEffect(
            layer,
            layerData.compositionEffect.id,
            layerData.compositionEffect
          );
          layer.compositionEffect = effect;
        }
      }
      flyer.layers.push(layer);
      console.log('ADDED LAYER');
    }
    let motionSource: MotionSource | undefined;
    let soundtrack: Soundtrack | null = null;
    if (motionData) {
      const motionSourceResult = await loadMotionSource({
        audioUrl: motionData.audioUrl,
        motionSource: isMotionSourceData(motionData) ? motionData : undefined
      });
      motionSource = motionSourceResult.motionSource;
      soundtrack = motionSourceResult.soundtrack;
    }
    if (soundtrack === null) {
      // reset effects signal if there is no soundtrack
      flyer.layers.forEach(l => {
        l.effects.forEach(f => {
          if (isSoundtrackSignal(f.signalSource)) {
            f.signalSource = SignalSource.Default;
          }
        });
      });
    }
    const payload: AddFigmaLayersPayload = {
      type: ADDED_FIGMA_LAYERS,
      showIntro: showIntro && getState().app.platform !== PlatformType.Figma,
      motionSource,
      soundtrack
    };
    dispatch(payload);
  };
};

export const updateFigmaPaymentStatus = (status: FigmaPaymentStatus) => {
  return { type: UPDATE_FIGMA_PAYMENT_STATUS, status };
};

export const editTimeline = (audioWaveSrc: string) => {
  return {
    type: EDIT_TIMELINE,
    src: audioWaveSrc
  };
};
export const cancelEditTimeline = () => {
  return {
    type: CANCEL_EDIT_TIMELINE
  };
};

export const editMotionSource = () => {
  return {
    type: EDIT_MOTION_SOURCE
  };
};
export const cancelEditMotionSource = () => {
  return {
    type: CANCEL_EDIT_MOTION_SOURCE
  };
};

export const showMusicSourceSelection = () => {
  return openModal(ModalType.PickMusicSource);
};

export const showGenreSelector = () => {
  return openModal(ModalType.ChooseGenre);
};

export const showLoopSelector = (genre: MusicGenre) => {
  return openModal(ModalType.ChooseLoop, genre);
};

export const showLabelDetails = (label: Label) => {
  return openModal(ModalType.LabelDetails, label, true);
};

export const showITunesSearch = () => {
  return openModal(ModalType.ITunesSearch);
};

export const confirmAccountDeletion = () => {
  return openModal(ModalType.DeleteAccount);
};

export const promptAddResolution = () => {
  return openModal(ModalType.AddResolution);
};

export const showExportOptions = () => {
  return async (dispatch: Function, getState: () => RootState) => {
    // if there is a single layer and no effects and no soundtrack show confirmation
    const { layers, soundtrack, previewedEffect } = getState().flyer;
    const layersCount = layers.length;
    let maxFramesCount = 1;
    layers.forEach(l => {
      maxFramesCount = Math.max(layersCount, l.frames.length);
    });
    let effectsCount = 0;
    layers.forEach(l => {
      if (l.compositionEffect?.visible) {
        effectsCount++;
      }
      l.effects.forEach(e => {
        if (e.visible) {
          effectsCount++;
        }
      });
    });
    if (previewedEffect) {
      effectsCount++;
    }
    const hasSoundtrack = soundtrack !== null;
    if (
      !hasSoundtrack &&
      maxFramesCount === 1 &&
      effectsCount === 0 &&
      layersCount === 1
    ) {
      const result = window.confirm(
        'You can add effects to your layers clicking their flash icon. Are you sure you want to export without effects?'
      );
      if (!result) {
        return;
      }
    }
    dispatch(openModal(ModalType.Export));
  };
};

export const showUnsplashSelector = (layerOrProperty?: Layer | TemplateUI) => {
  return openModal(ModalType.Unsplash, layerOrProperty);
};

export const showPatternSelector = (layer?: Layer) => {
  return openModal(ModalType.Patterns, layer);
};

export const showGradientSelector = (layer?: Layer) => {
  return openModal(ModalType.Gradients, layer);
};

export const showShapeSelector = (layer?: Layer) => {
  return openModal(ModalType.Shapes, { layer });
};

export const showSoundWaveSelector = (layer?: Layer) => {
  return async (dispatch: Function, getState: () => RootState) => {
    const { soundtrack } = getState().flyer;
    if (soundtrack) {
      dispatch(openModal(ModalType.SoundWaves, layer));
    } else {
      alert('Please add a soundtrack before adding a sound wave.');
    }
  };
};

export const showStickerSelector = (layer?: Layer) => {
  return openModal(ModalType.Stickers, layer);
};

export const showPartialSupportedBrowser = () => {
  return openModal(ModalType.UnsupportedBrowser, null, false, true);
};

export const showAddColorTheme = () => {
  return openModal(ModalType.AddColorTheme, null, true);
};

export const showUploadFont = (file: File, fontName: string) => {
  return openModal(ModalType.UploadCustomFont, { file, fontName }, true);
};

export const showBuyFigma = (intent: string) => {
  trackEvent('Show Buy Figma', { intent });
  return openModal(ModalType.BuyFigmaSubscription, null, true);
};

export const clickedSpacebar = () => {
  return async (dispatch: Function, getState: () => RootState) => {
    const { selectedFrame, openedModals } = getState().app;
    if (selectedFrame && selectedFrame instanceof TextFrame) {
      // console.log('THERE IS ALREADY A SELECTED FRAME');
      return;
    }
    const { layers } = getState().flyer;
    if (layers.length || !openedModals.length) {
      dispatch(togglePlayback());
    }
  };
};

export const CREATE_EMPTY_FLYER = 'CREATE_EMPTY_FLYER';
export const createEmptyFlyer = () => {
  return async (dispatch: Function, getState: () => RootState) => {
    trackEvent('Create Empty Flyer');
    window.location.hash = '';
    getState().app.history.replace('/');
    dispatch({
      type: CREATE_EMPTY_FLYER
    });
  };
};

export const IMPORT_DESIGN = 'IMPORT_DESIGN';
export const importDesign = () => {
  return async (dispatch: Function, getState: () => RootState) => {
    trackEvent('Import a design');
    window.location.hash = '';
    getState().app.history.replace('/');
    dispatch({
      type: IMPORT_DESIGN
    });
  };
};

export const createFlyerFromTemplate = (templateData: FlyerData) => {
  return async (dispatch: Function, getState: () => RootState) => {
    const user = getState().app.user;
    if (templateData.templateOptions?.isPro && !isPro(user)) {
      dispatch(showBuyingOptions('pro-template'));
      return;
    }
    dispatch({
      type: WILL_LOAD_EXAMPLE
    });
    const flyerType = FlyerType.New;
    const resolution = templateData.resolution;
    const layers = templateData.layers!.map((data: any): Layer => {
      const layer: Layer = new Layer();
      layer.populateFromObj({
        ...data,
        stageWidth: resolution.width,
        stageHeight: resolution.height
      });
      return layer;
    });
    for (const layer of layers) {
      await layer.load();
    }
    const { captions, captionsLanguageCode, templateUI, templateOptions } =
      templateData;
    if (captions) {
      layers.forEach(layer => {
        layer.frames.forEach(frame => {
          if (frame instanceof CaptionsFrame) {
            frame.tokens = captions;
          }
        });
      });
    }
    const motionSourceResult = await loadMotionSource(templateData);
    const autoPlay =
      !motionSourceResult.soundtrack ||
      getState().app.userHasInteractedWithPage;

    window.location.hash = '';
    getState().app.history.replace('/');

    dispatch({
      ...motionSourceResult,
      type: LOAD_EXAMPLE,
      flyerType,
      layers,
      resolution,
      autoPlay,
      templateId: templateData.id,
      templateUI,
      templateOptions,
      captions,
      captionsLanguageCode
    });
    trackEvent('Create from Template', { id: templateData.id });
  };
};

export const createFlyerFromTemplateId = (id: string) => {
  return async (dispatch: Function, getState: () => RootState) => {
    try {
      const data = await getTemplateById(id);
      dispatch(createFlyerFromTemplate(data));
    } catch {
      console.error(`Could not load template with id "${id}"`);
    }
  };
};

export const createFlyerFromData = (flyerData: FlyerData) => {
  return async (dispatch: Function, getState: () => RootState) => {
    let imagesCount = 0;
    if (flyerData.layers) {
      for (const layer of flyerData.layers) {
        for (const frame of layer.frames) {
          if (frame.type === FrameType.Image) {
            const imageData = frame as PictureFrameData;
            const blob = await loadFile(imageData.url);
            const file = new File([blob], `image-${imagesCount++}.png`);
            imageData.url = URL.createObjectURL(file);
          }
        }
      }
    }
    const { flyer } = getState();
    const { previewPixelRatio } = flyer;
    if (
      flyer.resolution.width !== flyerData.resolution.width ||
      flyer.resolution.height !== flyerData.resolution.height
    ) {
      dispatch(
        changeResolution(
          matchResolutionWithStandards(flyerData.resolution) ??
            flyerData.resolution
        )
      );
    }
    const layers: Layer[] = [];
    let effectsCount = 0;
    flyerData.layers!.forEach((layerData: LayerData) => {
      if (layerData.frames.length) {
        const layer = new Layer();
        layer.populateFromObj({
          ...layerData,
          stageWidth: flyerData.resolution.width * previewPixelRatio.value,
          stageHeight: flyerData.resolution.height * previewPixelRatio.value
        });
        layers.push(layer);
        effectsCount += (layerData.effects ?? []).length;
        if (layerData.compositionEffect !== undefined) {
          effectsCount++;
        }
      }
    });
    for (const layer of layers) {
      await layer.load();
    }
    dispatch(addLayers(layers));
    // if no effects or audio are present in the data, show onboarding
    const hasAudio =
      flyerData.audio !== undefined || flyerData.audioUrl !== undefined;
    const hideFromDataOnboard =
      getValueFromLocalStorage(SKIP_FROM_DATA_ONBOARDING_STORAGE_KEY) ===
      'true';
    if (!hasAudio && effectsCount === 0 && !hideFromDataOnboard) {
      dispatch(openModal(ModalType.FromDataOnboarding));
    }
  };
};

export const exportImage = () => {
  return async (dispatch: Function, getState: () => RootState) => {
    trackEvent('Download media', { recordType: 'image' });
    const { resolution } = getState().flyer;
    const tempTexture = PIXI.RenderTexture.create(
      resolution.width,
      resolution.height
    );
    const renderer = getRenderer();
    const stage = getStage();
    if (!stage) {
      alert('Stage is missing');
      return;
    }
    renderer.render(stage, tempTexture);
    let canvas: HTMLCanvasElement =
      renderer.plugins.extract.canvas(tempTexture);
    tempTexture.destroy();
    const isIOSApp = getState().app.platform === PlatformType.iOSApp;
    if (isIOSApp) {
      postMessageToIosWrapper('exportImage', {
        imageURL: canvas.toDataURL().split(',')[1]
      });
    } else {
      download(
        canvas.toDataURL(),
        `${getExportedFileName(getState().flyer)}.png`,
        'image/png'
      );
    }
    dispatch(closeModal(isIOSApp));
  };
};

export const CHANGE_TEMPLATE_EDIT_MODE = 'CHANGE_TEMPLATE_EDIT_MODE';
export const changeTemplateEditMode = (mode: TemplateEditMode) => {
  return async (dispatch: Function, getState: () => RootState) => {
    const { templateEditMode } = getState().app;
    if (mode === templateEditMode) {
      return;
    }
    dispatch({
      type: CHANGE_TEMPLATE_EDIT_MODE,
      mode
    });
  };
};

let lastTemplateFrameImage: { [key: string]: string } = {};
export const changeTemplateProperty = (property: TemplateUI, value: any) => {
  return async (dispatch: Function, getState: () => RootState) => {
    const changeBindedTemplateProperty = async (
      path: string,
      options: TemplateUIBindOptions | null = null
    ) => {
      const inverted = path.startsWith('!');
      if (inverted) {
        path = path.substring(1);
      }
      const { node, effect, propertyName } = parseBindPath(path);
      if (node) {
        if (
          property.type === TemplateUIType.Boolean &&
          propertyName === 'visible'
        ) {
          if (!(node instanceof Frame)) {
            (effect ?? node).visible = inverted ? !value : value;
            if (effect) {
              node.applyEffects();
            }
          }
        } else if (property.type === TemplateUIType.Image) {
          const frame = node as Frame;
          const newFrame = new PictureFrame(
            frame.stageWidth,
            frame.stageHeight
          );
          newFrame.id = frame.id;
          newFrame.type = FrameType.Image;
          if (options?.removeBackground) {
            dispatch(
              openModal(
                ModalType.Processing,
                'Removing background',
                false,
                true
              )
            );
            const transparentFilenameUrl = await removeBackground(value, true);
            const blob = await loadFile(transparentFilenameUrl);
            const file = new File([blob], 'photo.png');
            newFrame.file = file;
            newFrame.filename = file.name;
            // await deleteFile(transparentFilename); // not needed with Removal.ai
            dispatch(closeModal());
          } else {
            if (value instanceof File) {
              const file = value as File;
              newFrame.file = file;
              newFrame.filename = file.name;
            } else if (typeof value === 'string') {
              newFrame.url = value;
              lastTemplateFrameImage[frame.id] = value;
            }
          }
          await newFrame.load();
          const thumbnailURL = await newFrame.getThumbnailURL();
          newFrame.backgroundStyle = await getBackgroundStyleFromImageURL(
            thumbnailURL
          );
          if (options && options.rect && options.contentMode) {
            const { rect, contentMode } = options;
            const imageWidth = newFrame.texture!.width;
            const imageHeight = newFrame.texture!.height;
            const scaleX = rect.width / imageWidth;
            const scaleY = rect.height / imageHeight;
            let scale = 1;
            switch (contentMode) {
              case TemplateImageContentMode.Fit:
                scale = Math.min(scaleX, scaleY);
                break;
              case TemplateImageContentMode.Fill:
                scale = Math.max(scaleX, scaleY);
                break;
              default:
                break;
            }
            const width = imageWidth * scale;
            const height = imageHeight * scale;
            const cx = rect.x + rect.width * 0.5;
            const cy = rect.y + rect.height * 0.5;
            const x = cx - width * 0.5;
            const y = cy - height * 0.5;
            newFrame.boundingBox = new PIXI.Rectangle(x, y, width, height);
          }

          if (
            typeof value !== 'string' ||
            value === lastTemplateFrameImage[frame.id]
          ) {
            // make sure it's not loading another image
            const layer = getState().flyer.layers.find(l =>
              l.frames.includes(frame)
            )!;
            dispatch({
              type: REPLACE_FRAME,
              layer,
              oldFrame: frame,
              newFrame
            });
          }
        } else if (
          property.type === TemplateUIType.Text &&
          options &&
          options.forceOneLine
        ) {
          (node as TextFrame).setOneLineText(value);
        } else if (
          property.type === TemplateUIType.Color &&
          propertyName.endsWith('[rgb]')
        ) {
          // change only the rgb value, not the alpha
          const currentHex = node['color'] as string;
          if (currentHex.length === 9) {
            // has alpha
            const alphaHex = currentHex.substr(7);
            node['color'] = value + alphaHex;
          } else {
            node['color'] = value;
          }
        } else {
          if (effect) {
            effect.setProperty(propertyName, value);
          } else {
            node[propertyName] = value;
          }
        }
        // force text composition update
        if (node instanceof TextFrame && node.type === FrameType.Text) {
          const parentLayer = getState().flyer.layers.find(l =>
            l.frames.includes(node)
          );
          if (
            parentLayer &&
            parentLayer.compositionEffect &&
            parentLayer.compositionEffect.isText
          ) {
            parentLayer.compositionEffect.reset();
          }
        } else if (node instanceof CaptionsFrame) {
          // properties are likely to be only styles
          node.didChangeStyle(propertyName);
        }
      }
    };

    const items = Array.isArray(property.bind)
      ? property.bind
      : [property.bind];
    for (const b of items) {
      if (typeof b === 'string') {
        await changeBindedTemplateProperty(b);
      } else {
        const obj = b as TemplateUIBind;
        await changeBindedTemplateProperty(obj.node, obj.options);
      }
    }
    document.dispatchEvent(new Event(TEMPLATE_PROPERTY_CHANGED));
    dispatch({ type: TEMPLATE_PROPERTY_CHANGED });
  };
};

export const didBlurTemplateInputText = (property: TemplateUI) => {
  return async (dispatch: Function, getState: () => RootState) => {
    const updateThumbnail = (path: string) => {
      const { node } = parseBindPath(path);
      if (node && node instanceof TextFrame) {
        node.generateThumbnail();
      }
    };
    const items = Array.isArray(property.bind)
      ? property.bind
      : [property.bind];
    for (const b of items) {
      if (typeof b === 'string') {
        await updateThumbnail(b);
      } else {
        const obj = b as TemplateUIBind;
        await updateThumbnail(obj.node);
      }
    }
  };
};

export const TEMPLATE_INTRO_CHANGED = 'TEMPLATE_INTRO_CHANGED';
export const changeTemplateIntroAnimation = (intro: TemplateUIIntroType) => {
  return async (dispatch: Function, getState: () => RootState) => {
    console.log('changeTemplateIntroAnimation: ' + intro);
    const { layers, motionSource, resolution } = getState().flyer;
    if (intro === TemplateUIIntroType.None) {
      layers.forEach(layer => {
        layer.compositionEffect?.reset();
        layer.compositionEffect = null;
        layer.timeline.visibility.reset();
      });
    } else {
      const visibleLayers = layers.filter(l => l.visible);
      while (
        visibleLayers.length > 0 &&
        visibleLayers[0].frames[0].type === FrameType.SolidColor
      ) {
        visibleLayers.shift();
      }
      const stageSurface = resolution.width * resolution.height;
      const isSmall = (frame: Frame): boolean => {
        const surface = frame.boundingBox.width * frame.boundingBox.height;
        return surface < stageSurface / 2;
      };
      visibleLayers.sort((a, b): number => {
        const frameA = a.frames[0];
        const frameB = b.frames[0];
        const smallA = isSmall(frameA);
        const smallB = isSmall(frameB);
        if (!smallA && !smallB) {
          return 0;
        }
        if (!smallA) {
          return -1;
        }
        if (!smallB) {
          return 1;
        }
        const yA = frameA.boundingBox.y + frameA.boundingBox.height * 0.5;
        const yB = frameB.boundingBox.y + frameB.boundingBox.height * 0.5;
        return yA - yB;
      });
      const offSetInSeconds = 0.15;
      const durationInSeconds = motionSource.getDuration() * 0.001;
      const offSetRelative = offSetInSeconds / durationInSeconds;
      let start = 0;
      visibleLayers.forEach(layer => {
        layer.setTimelineStartAndEnd(start, 1 - start);
        layer.compositionEffect?.reset();
        switch (intro) {
          case TemplateUIIntroType.Fade:
            layer.compositionEffect = CompositionEffect.createCompositionEffect(
              layer,
              'composition-fade'
            );
            break;
          case TemplateUIIntroType.Slide:
            layer.compositionEffect = CompositionEffect.createCompositionEffect(
              layer,
              'composition-slide',
              {
                id: 'composition-slide',
                props: {
                  direction: DIRECTION_VERTICAL,
                  inDuration: DURATION_LONG,
                  outDuration: DURATION_LONG,
                  symmetric: true
                }
              }
            );
            break;
          default:
            break;
        }
        start += offSetRelative;
      });
    }
    dispatch({ type: TEMPLATE_INTRO_CHANGED, intro });
    dispatch(jumpPlayback(0));
  };
};

export const selectMask = (layer: Layer) => {
  return { type: SELECT_MASK, layer };
};

export const unselectMask = () => {
  return { type: SELECT_MASK, layer: null };
};

export const showAddMaskModal = (layer: Layer) => {
  return openModal(ModalType.Shapes, { layer, isMask: true });
};
export const MASK_CHANGED = 'MASK_CHANGED';

export const UPDATE_FRAMES_RELATIVE_DURATIONS =
  'UPDATE_FRAMES_RELATIVE_DURATIONS';
export const updateFramesRelativeDurations = (
  layer: Layer,
  relativeDurations: number[]
) => {
  // total should be 1
  // const totalDuration = relativeDurations.reduce(
  //   (tot: number, duration: number): number => {
  //     return tot + duration;
  //   },
  //   0
  // );
  // console.log('total duration: ' + totalDuration);
  for (let i = 0; i < layer.frames.length; i++) {
    layer.frames[i].relativeDuration = relativeDurations[i];
  }
  return {
    type: UPDATE_FRAMES_RELATIVE_DURATIONS
  };
};

export const IMAGE_GIF_ANIMATED = 'IMAGE_GIF_ANIMATED';

export const showTemplateImageReplaceOptions = (property: TemplateUI) => {
  return openModal(ModalType.TemplateImageReplacement, property);
};

export const SAVE_CAPTIONS = 'SAVE_CAPTIONS';
export const saveCaptions = (
  captions: CaptionsToken[],
  languageCode: string
) => {
  return async (dispatch: Function, getState: () => RootState) => {
    const { flyer } = getState();
    const currentCaptions = flyer.captions;
    const currentLanguage = flyer.captionsLanguageCode;
    if (
      JSON.stringify(currentCaptions) !== JSON.stringify(captions) ||
      currentLanguage !== languageCode
    ) {
      dispatch(new AddCaptionsCommand(captions, languageCode));
    }
    dispatch(closeModal());
  };
};

export const changedTranscribeSpokenLanguage = (languageCode: string) => {
  return async (dispatch: Function, getState: () => RootState) => {
    const { user } = getState().app;
    if (user) {
      await updateTranscribeSpokenLanguage(user.uid, languageCode);
    }
    setValueInLocalStorage(TRANSCRIBE_LANGUAGE_STORAGE_KEY, languageCode);
  };
};

export const THEME_CHANGED = 'THEME_CHANGED';
export const themeDidChange = (theme: ColorTheme) => {
  return {
    type: THEME_CHANGED,
    theme
  };
};

export const DETATCH_COLOR_THEME = 'DETATCH_COLOR_THEME';
export const detachColorTheme = () => {
  return {
    type: DETATCH_COLOR_THEME
  };
};

export const UPDATE_USER_COLOR_THEMES = 'UPDATE_USER_COLOR_THEMES';
export const addColorTheme = (theme: ColorTheme) => {
  return async (dispatch: Function, getState: () => RootState) => {
    const { user } = getState().app;
    if (user) {
      const themes = (user.colorThemes ?? []).concat([theme]);
      await setUserColorThemes(user.uid, themes);
      dispatch({
        type: UPDATE_USER_COLOR_THEMES,
        themes
      });
    }
    dispatch(closeModal());
  };
};
export const removeColorTheme = (index: number) => {
  return async (dispatch: Function, getState: () => RootState) => {
    const { user } = getState().app;
    if (user) {
      const themes = [...(user.colorThemes ?? [])];
      themes.splice(index, 1);
      await setUserColorThemes(user.uid, themes);
      dispatch({
        type: UPDATE_USER_COLOR_THEMES,
        themes
      });
    }
    dispatch(closeModal());
  };
};

export const uploadCustomFont = (file: File, name: string) => {
  return async (dispatch: Function, getState: () => RootState) => {
    trackEvent('Upload font', { name: file.name });
    const { user } = getState().app;
    if (user !== null) {
      const extension = file.name.split('.').pop() ?? '';
      if (!['ttf', 'otf'].includes(extension)) {
        alert(`Extension ${extension} is not supported.`);
      } else {
        const filename = `${newUUID()}.${extension}`;
        const key = `users/${user.uid}/${filename}`;
        await uploadFile(key, file, file.type);
        const url = getBaseURL() + key;
        console.log('Uploaded:', url);
        const newFont: CustomFont = {
          name,
          url
        };
        const customFonts = (user.customFonts ?? []).concat([newFont]);
        await setUserCustomFonts(user.uid, customFonts);
        user.customFonts = customFonts;
        await loadCustomFont(newFont);
        dispatch(
          updateUser({
            ...user,
            customFonts
          })
        );
      }
    }
    dispatch(closeModal());
  };
};
export const deleteCustomFont = (name: string) => {
  return async (dispatch: Function, getState: () => RootState) => {
    const { user } = getState().app;
    if (user !== null && user.customFonts !== undefined) {
      const fontToDelete = user.customFonts.find(f => f.name === name);
      if (fontToDelete !== undefined) {
        const index = user.customFonts.indexOf(fontToDelete);
        const newCustomFonts = cloneObject(user.customFonts);
        newCustomFonts.splice(index, 1);
        await setUserCustomFonts(user.uid, newCustomFonts);
        const key = fontToDelete.url.substring(getBaseURL().length);
        await deleteFile(key);
        dispatch(
          updateUser({
            ...user,
            customFonts: newCustomFonts
          })
        );
      }
    }
  };
};

export const showSegmentationSurvey = () => {
  return openModal(ModalType.SegmentationSurvey, undefined, true);
};



// WEBPACK FOOTER //
// ./src/state/actions/index.ts